module.exports = __webpack_public_path__ + "static/Offsetra-3a915723fe4ca6d5698f9621836cef55.jpg";